module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_pp1_9006.f1b98a1c.png";